import { Box, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LABEL_PO } from "../../../constants/constant";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalAddPo = ({ openModal, setOpenModal, isWarehouse }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Modal open={openModal} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "85%",
            overflowY: "auto",
            overflowX: "wrap",
            maxHeight: "80vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-2/3"
        >
          <div className="px-8 py-4">
            <div className="mb-4">
              <p className="font-bold text-[16px]">Buat PO</p>
              <p>Silahkan pilih jenis obat yang akan di PO</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 items-center text-center">
              {LABEL_PO.map((item, i) => (
                <p
                  className="w-full p-2 border rounded-md h-full cursor-pointer hover:bg-gray-100"
                  onClick={() =>
                    navigate(
                      `${
                        isWarehouse ? "/central-warehouse" : ""
                      }/purchase-order/create-po/${item.id}`
                    )
                  }
                >
                  {item.label_name}
                </p>
              ))}
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ModalAddPo;
